import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=b32c4b02"
import script from "./UsersManagement.vue?vue&type=script&lang=js"
export * from "./UsersManagement.vue?vue&type=script&lang=js"
import style0 from "./UsersManagement.vue?vue&type=style&index=0&id=b32c4b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports